// extracted by mini-css-extract-plugin
export default {"wrapper":"un-z","response":"vn-z","error":"wn-z","disabled":"xn-z","buttons":"yn-z","feedbackQuestionSection":"zn-z","yesNoWrapper":"An-z"};